<template>
  <el-card v-loading="loading">
    <el-form label-width="250px">
      <el-form-item
        label="Enable Security Fee"
      >
        <el-switch
          v-model="securityFee.enabled"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="Add Security Fee"
          inactive-text="No Security Fee"
          :disabled="!hasAccess"
          @change="setSecurityFeeFlag"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="Security Fee in cents per square foot">
        <el-input-number
          v-if="securityFee && securityFee.enabled"
          v-model.number="securityFee.fee"
          :precision="0"
          :min="0"
          :disabled="!hasAccess"
          @change="enableSaveButton"
        >
        </el-input-number>
      </el-form-item>
      <el-form-item label="Security Fee name">
        <el-input
          v-if="securityFee && securityFee.enabled"
          clearable
          v-model="securityFee.label"
          :disabled="!hasAccess"
          @input="enableSaveButton"
          style="width: 20rem"
        >
        </el-input>
      </el-form-item>
        <el-button v-if="hasAccess" :disabled="!editForm" @click="saveSecurityFeeValue">
          Save
        </el-button>
    </el-form>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'FacilitySecurityFeeSettings',
  props: { facility: { type: String, required: true } },
  async mounted() {
    this.loading = true;
    const facility = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
      headers: {
        Authorization: `Bearer ${this.$keycloak.token}`,
      },
    });
    this.getFacilitySecurityFee(facility.data);
    this.loading = false;
  },
  computed: {
    hasAccess() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      if (roles.includes('level_1')) {
        return true;
      }
      return false;
    },
  },
  watch: {
    async facility() {
      this.loading = true;
      const facility = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.getFacilitySecurityFee(facility.data);
      this.loading = false;
    },
  },
  data() {
    return {
      loading: true,
      securityFee: {
        enabled: false,
        fee: 0,
        label: 'Security',
      },
      editForm: false,
    };
  },
  methods: {
    enableSaveButton() {
      if (this.securityFee.label.replace(/ /g, '') === '') {
        this.securityFee.label = this.securityFee.label.replace(/ /g, '');
      }
      this.editForm = true;
    },
    async saveSecurityFeeValue() {
      this.loading = true;
      const updatedFacility = await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        securityFee: this.securityFee,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.getFacilitySecurityFee(updatedFacility.data);
      this.loading = false;
      this.$message.success({
        title: 'Success',
        message: 'Successfully updated Security Fee.',
      });
      this.editForm = false;

      this.$emit('reload-facility');
    },
    getFacilitySecurityFee(facility) {
      this.securityFee = facility.securityFee;

      if (!this.securityFee) {
        this.securityFee = {
          enabled: false,
          fee: 0,
        };
      }
    },
    async setSecurityFeeFlag(flag) {
      try {
        this.loading = true;
        const updatedFacility = await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          securityFee: {
            enabled: flag,
            fee: this.securityFee.fee,
          },
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.getFacilitySecurityFee(updatedFacility.data);
        this.loading = false;
        this.$message.success({
          title: 'Success',
          message: flag ? 'Security Fee Enabled successfully' : 'Security fee disabled successfully',
        });
      } catch (err) {
        this.$message.error({
          title: 'Error',
          message: err.message ? err.message : err.resposne.data.toUpperCase(),
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FacilitySecurityFee.vue